import { plugin, type TabProps } from 'light-component';
import { Tabs } from 'antd';
import { t } from '../../i18n';
import type { ReactElement } from 'react';

export function WidgetTab(props: TabProps): ReactElement {
  return (
    <div>
      <Tabs activeKey={props.value} onChange={(key: string | null) => key != null && props.onSelect?.(key)}>
        {props.options.map(item => (
          <Tabs.TabPane key={item.value} tab={t(item.title)} forceRender={true}>
            {item.children}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'tab', component: WidgetTab });
